import React, { useEffect, useState } from "react";
import {
  Spin,
  Card,
  Form,
  Col,
  Avatar,
  Tag,
  Row,
  InputNumber,
  Popover,
  Modal,
  Button,
  Input,
} from "antd";

import { FONT, USER_STORAGE } from "constants/index";
import {
  notificationErroInternal,
  notificationInfo,
  notificationSucessMsg,
} from "util/api-utils";
import {
  getPlanningUserById,
  saveTraining,
} from "services/planning/planning-service";
import { getById } from "services/user/user-service";
import ManagerialChart from "./managerial-drawer-chart";
import { getUsersBootById } from "services/boot/boot-service";
import TimelineBoot from "./managerial-timeline-boot";
import { UserRound } from "lucide-react";
import { translationsTypes } from "../planning/columns-table";
import moment from "moment";
import { resetPassword } from "services/login/login-service";
const { Meta } = Card;

const ManagerialUser = () => {
  const [loading, setLoading] = useState(true);
  const [userTrainer, setUserTrainer] = useState(null);
  const [isBoot, setIsBoot] = useState(null);
  const [activeTraining, setActiveTraining] = useState(false);
  const [user, setUser] = useState(null);
  const [formRefNewPassword] = Form.useForm();
  const [isLoadingPassword, setIsLoadingPassword] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const localStorageItem = localStorage.getItem(USER_STORAGE);
    if (localStorageItem != null) {
      const { id } = JSON.parse(localStorageItem);
      getById(id).then((res) => {
        setIsBoot(res.isBoot);
        setIsModalOpen(res.shouldResetPassword);
        setUser(res);
        getData(res);
      });
    }
  }, [localStorage.getItem(USER_STORAGE)]);

  function getData(user) {
    if (user?.id) {
      var funcGet =
        user.isBoot == true ? getUsersBootById : getPlanningUserById;

      funcGet(user?.id)
        .then((res) => {
          const userTraining =
            user.isBoot == true
              ? {
                  id: user?.id,
                  allTrainings: res.allTrainings,
                  img: user.img,
                  training: res.training,
                  name: user?.name,
                }
              : {
                  id: user?.id,
                  planningTrainings: res[0]?.training,
                  img: user.img,
                  name: user?.name,
                  control: res[0]?.control,
                  planningId: res[0]?.exercises[0]?.planningId,
                };

          if (user.isBoot != true) {
            const training = res[0]?.training ?? [];
            const backSquad = training.find(
              (item) => item.planningType == "BACK_SQUAD"
            );
            const hasOpen = backSquad?.trainings.find(
              (item) => item.forceOpen == true
            );
            const lastTraining = backSquad?.allTrainings?.findLast(
              (item) => item.isDone == true
            )?.updatedAt;
            let lastTrainindDate = "";
            if (lastTraining) {
              lastTrainindDate = moment(lastTraining);
            }
            const nowDate = moment(new Date());

            let showTraining = false;
            if (
              lastTrainindDate != "" &&
              lastTrainindDate?.format("DD/MM/YYYY") !=
                nowDate?.format("DD/MM/YYYY")
            ) {
              showTraining = true;
            }
            if (lastTrainindDate == "") {
              showTraining = true;
            }
            if (hasOpen) {
              showTraining = true;
            }

            if ((user?.isSession == true || hasOpen) && showTraining) {
              setActiveTraining(true);
            } else {
              setActiveTraining(false);
            }
          }

          setUserTrainer(userTraining);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          notificationErroInternal(
            "Aconteceu um erro inesperado, por favor, tente mais tarde"
          );
        });
    }
  }
  function getTranslationType(exercise) {
    var name =
      exercise.planningType == "ADDITIONAL_EXERCISE"
        ? exercise.additionalName
        : exercise.planningType == "NEW_EXERCISE"
        ? exercise.nameCvNew
        : translationsTypes[exercise.planningType];
    return name;
  }
  const DescriptionItem = ({ title }) => (
    <div
      className="site-description-item-profile-wrapper"
      style={{ fontFamily: FONT, fontSize: 16 }}
    >
      <b>{title}</b>
    </div>
  );
  const contentScoreDrop = (
    <div>
      <p>
        Queda ≤ 2% → Excelente – Atleta recuperado e pronto para treinar em alta
        intensidade
      </p>
      <p>
        Queda entre 2% e 5% → Bom – Atleta recuperado, mas pode precisar de
        pequenos ajustes no volume
      </p>
      <p>
        Queda entre 5% e 10% → Moderado – Indica sinais de fadiga; pode ser
        necessário reduzir o volume do treinamento
      </p>
      <p>
        Queda entre 10% e 15% → Ruim – Indica cansaço acumulado; sugere
        necessidade de um treino estabilizador ou ajuste no volume e na
        intensidade do treino
      </p>
      <p>
        Queda superior a 15% → Crítico – Indica risco de overtraining; é
        recomendado descanso completo ou um ajuste profundo na carga de
        treinamento
      </p>
    </div>
  );
  const contentScoreWellBeing = (
    <div>
      <p>
        4,5 a 5,0 → Excelente – Atleta recuperado e pronto para treinar em alta
        intensidade.
      </p>
      <p>
        3,5 a 4,4 → Bom – Atleta recuperado, mas pode precisar de ajustes
        menores na carga de treino.
      </p>
      <p>
        2,5 a 3,4 → Moderado – Indica sinais de fadiga; pode ser necessário
        reduzir a carga ou fazer um treino mais leve.
      </p>
      <p>
        1,5 a 2,4 → Ruim – Indica cansaço acumulado; sugere necessidade de
        descanso ativo ou ajuste significativo na carga.
      </p>
      <p>
        1,0 a 1,4 → Crítico – Indica risco de overtraining; é recomendado
        descanso completo ou um ajuste profundo no ciclo de treino.
      </p>
    </div>
  );
  function getWeek(planningExercise, name) {
    const week = planningExercise[0]?.trainings[0]?.load;
    const type = planningExercise[0]?.trainings[0]?.orderTraining;

    if (week) {
      const typeTraining = type % 2 === 0 ? "B" : "A";
      const color = type % 2 === 0 ? "geekblue" : "green";

      return (
        <div>
          {name} - Semana {week} -{" "}
          <Tag color={color} key={typeTraining}>
            {typeTraining.toUpperCase()}
          </Tag>
        </div>
      );
    }
    return name + " - Cíclo Finalizado";
  }
  function hasBackSquad(exercises) {
    return (
      exercises.filter((item) => item.planningType == "BACK_SQUAD").length > 0
    );
  }
  const Exercises = ({ exercises }) => {
    const last = exercises[0]?.allTrainings.slice(-1);

    const load = exercises[0]?.trainings[0]?.load ?? last[0]?.load ?? 1;

    return (
      <div
        style={{
          maxHeight: 120,
          overflowY: "auto",
          overflowX: "auto",
        }}
      >
        {exercises.map((exercise, index) => (
          <Col style={{ minWidth: 450 }}>
            <Row key={index}>
              {" "}
              <Col span={8}>
                <DescriptionItem title={getTranslationType(exercise)} />
              </Col>
              <Col span={3}>
                <DescriptionItem title={exercise[`load${load}`] + "kg"} />
              </Col>
              <Col span={5}>
                <DescriptionItem
                  title={
                    exercise[`vmp${load}`] != null
                      ? exercise[`vmp${load}`] + " - VMP"
                      : ""
                  }
                />
              </Col>
              <Col span={8}>
                <DescriptionItem
                  title={
                    exercise[`rm${load}`] != null
                      ? exercise.planningType == "BARBELL_JUMP"
                        ? exercise[`rm${load}`] + " - ALT(CM)"
                        : exercise[`rm${load}`] + " - %1RM"
                      : ""
                  }
                />
              </Col>
            </Row>
          </Col>
        ))}
      </div>
    );
  };
  function getScoreControl(value, showScore) {
    let color = "green";
    if (value < -10) {
      color = "red";
    }
    if (value <= -6 && value >= -10) {
      color = "yellow";
    }

    if (showScore) {
      return (
        <Popover content={contentScoreDrop} title="Valores de Queda">
          <div>
            <Tag color={color}>{value}</Tag>
          </div>
        </Popover>
      );
    } else {
      return (
        <div>
          <Tag color={color}>{value}</Tag>
        </div>
      );
    }
  }
  function getScoreControlWellBeing(value) {
    let color = "green";
    if (value < 1.5) {
      color = "red";
    }
    if (value < 2.5 && value >= 1.5) {
      color = "orange";
    }
    if (value < 3.5 && value >= 2.5) {
      color = "yellow";
    }
    if (value < 4.5 && value >= 3.5) {
      color = "blue";
    }
    return (
      <Popover content={contentScoreWellBeing} title="Interpretação Score">
        <div>
          <Tag color={color}>{value}</Tag>
        </div>
      </Popover>
    );
  }
  const CardTrainings = () => {
    const [formUser] = Form.useForm();
    const user = userTrainer;
    if (user == null) {
      return <div></div>;
    }
    const planExercise =
      user?.planningTrainings?.filter((p) => p.planningType == "BACK_SQUAD") ??
      [];
    let isOpen = false;
    if (planExercise.length > 0) {
      const exercise = planExercise[0].trainings;
      if (exercise.length > 0) {
        isOpen = exercise[0].forceOpen;
        formUser.setFieldValue("vmp1", exercise[0].vmp1);
        formUser.setFieldValue("vmp2", exercise[0].vmp2);
        formUser.setFieldValue("vmp3", exercise[0].vmp3);
        formUser.setFieldValue("vmp4", exercise[0].vmp4);
      }
    }

    return (
      <Col key={user.id} span={outerWidth < 800 ? 24 : 24}>
        <Card
          style={{
            width: "100%",
            marginBottom: 16,
            minHeight: 400,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Meta
            avatar={
              outerWidth < 800 ? <div></div> :  <Avatar
              src={user?.img}
              icon={<UserRound size={80} />}
              size={80}
            />
             
            }
            title={<div>{getWeek(user.planningTrainings, user.name)}</div>}
            description={
              <div>
                <Row>
                  <Col span={9}>
                    <DescriptionItem title={"Exercícios"} />
                  </Col>
                </Row>
                <Exercises exercises={user.planningTrainings} />

                {hasBackSquad(user.planningTrainings) && (
                  <>
                    <Row style={{ marginTop: 10 }}>
                      <Col span={24}>
                        <DescriptionItem title={"VMP Agachamento"} />
                      </Col>
                    </Row>
                    <Form form={formUser} layout="vertical">
                      <Row gutter={16}>
                        <Col span={6}>
                          <Form.Item name="vmp1">
                            <InputNumber
                              decimalSeparator=","
                              style={{ fontFamily: FONT, width: "100%" }}
                              onBlur={() =>
                                setVmp(formUser, user.planningId, isOpen)
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col span={6}>
                          <Form.Item name="vmp2">
                            <InputNumber
                              decimalSeparator=","
                              style={{ fontFamily: FONT, width: "100%" }}
                              onBlur={() =>
                                setVmp(formUser, user.planningId, isOpen)
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col span={6}>
                          <Form.Item name="vmp3">
                            <InputNumber
                              decimalSeparator=","
                              style={{ fontFamily: FONT, width: "100%" }}
                              onBlur={() =>
                                setVmp(formUser, user.planningId, isOpen)
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col span={6}>
                          <Form.Item name="vmp4">
                            <InputNumber
                              decimalSeparator=","
                              style={{ fontFamily: FONT, width: "100%" }}
                              onBlur={() =>
                                setVmp(formUser, user.planningId, isOpen)
                              }
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Form>
                  </>
                )}
                {user.control && (
                  <>
                    <Row>
                      <Col span={4}>
                        <DescriptionItem title={"CMJ PRÉ"} />
                      </Col>
                      <Col span={4}>
                        <DescriptionItem title={"QUEDA %"} />
                      </Col>
                      <Col span={6}>
                        <DescriptionItem title={"SCORE"} />
                      </Col>
                      <Col span={4}>
                        <DescriptionItem title={"CMJ PÓS"} />
                      </Col>
                      <Col span={4}>
                        <DescriptionItem title={"QUEDA %"} />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={4}>
                        <DescriptionItem title={user.control.cmjFirst} />
                      </Col>
                      <Col span={4}>
                        <DescriptionItem
                          title={getScoreControl(
                            user.control.cmjFirstDrop,
                            true
                          )}
                        />
                      </Col>
                      <Col span={6}>
                        <DescriptionItem
                          title={getScoreControlWellBeing(
                            user.control.averageWellBeing
                          )}
                        />
                      </Col>
                      <Col span={4}>
                        <DescriptionItem title={user.control.cmjSecond} />
                      </Col>
                      <Col span={4}>
                        <DescriptionItem
                          title={getScoreControl(user.control.cmjSecondDrop)}
                        />
                      </Col>
                    </Row>
                  </>
                )}
              </div>
            }
          />
        </Card>
      </Col>
    );
  };
  function setVmp(formUser, planningId, isOpen, forceClose) {
    setLoading(true);
    const obj = {
      isDone: false,
      planningId: [planningId],
      vmp1: formUser.getFieldValue("vmp1"),
      vmp2: formUser.getFieldValue("vmp2"),
      vmp3: formUser.getFieldValue("vmp3"),
      vmp4: formUser.getFieldValue("vmp4"),
      isOpen: isOpen,
      forceClose: forceClose,
    };
    saveTraining(obj)
      .then(() => {
        getData(user);
      })
      .catch((err) => {
        setLoading(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde"
        );
      });
  }

  const handleOk = () => {
    setIsLoadingPassword(true);
    formRefNewPassword
      .validateFields()
      .then((values) => {
        if (values.password != values.confirmPassword) {
          notificationInfo("As senhas devem ser iguais!");
          setIsLoadingPassword(false);
          return;
        }

        const request = {
          id: user.id,
          password: values.password,
        };
        resetPassword(request)
          .then(() => {
            notificationSucessMsg("Senha alterada com sucesso!");
            handleCancel();
          })
          .catch((err) => {
            setIsLoadingPassword(false);
            notificationErroInternal(
              "Aconteceu um erro inesperado, por favor, tente mais tarde"
            );
          });
      })
      .catch((errors) => {
        setIsLoadingPassword(false);
        console.log(errors);
      });
  };

  const handleCancel = () => {
    formRefNewPassword.resetFields();
    setIsModalOpen(false);
    setIsLoadingPassword(false);
  };

  return (
    <div className="container-managerial">
      <Spin size="large" spinning={loading}>
        {activeTraining == true && <CardTrainings />}
        <Card style={{ backgroundColor: "#ffffff" }}>
          {isBoot == true ? (
            <TimelineBoot user={userTrainer} />
          ) : (
            <ManagerialChart user={userTrainer} />
          )}
        </Card>
      </Spin>
      <Modal
        className="modal-password"
        style={{ textAlign: "center" }}
        title="Definir Nova Senha"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancelar
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={isLoadingPassword}
            onClick={handleOk}
          >
            Salvar
          </Button>,
        ]}
      >
        <Form
          form={formRefNewPassword}
          layout={"vertical"}
          style={{ maxWidth: 600, fontFamily: FONT }}
        >
          <Form.Item
            label="Senha"
            name="password"
            rules={[
              {
                required: true,
                message: "È necessário informar a senha",
              },
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            label="Confirmar Senha"
            name="confirmPassword"
            rules={[
              {
                required: true,
                message: "È necessário informar a confirmação de senha",
              },
            ]}
          >
            <Input.Password />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};
export default ManagerialUser;
